// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".country-brands-page__region{border-top:1px solid #ececec}.country-brands-page__section-block{margin-bottom:0}html.view_desktop .country-brands-page__section-block{--desktop-header-padding-top:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
